
import React, { Component } from 'react';

export default function withRoute(WrappedComponent) {
    return class extends Component {
        componentDidMount() {
            document.documentElement.scrollTop = document.querySelector('#root').scrollTop = 0;
        }

        render() {
            return (
                <WrappedComponent {...this.props} />
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/hocs/withRoute.js